import { render, staticRenderFns } from "./inter.vue?vue&type=template&id=01402b9b&scoped=true&"
import script from "./inter.vue?vue&type=script&lang=js&"
export * from "./inter.vue?vue&type=script&lang=js&"
import style0 from "./inter.vue?vue&type=style&index=0&id=01402b9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01402b9b",
  null
  
)

export default component.exports